import { FormControl } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(FormControl)`
  width: 100%;

  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;
